import { BUTTON_VARIANTS } from '@belong/themes';
import { IButton } from '@belong/types';

interface IButtonBaseState {
  variant: NonNullable<IButton['variant']>;
  isLoading?: boolean;
  disabled?: boolean;
  icon?: IButton['icon'];
  hasHref: boolean;
  isInlineSpinnerLoading: boolean;
}

export const getButtonState = ({
  variant,
  isLoading,
  disabled,
  icon,
  hasHref,
  isInlineSpinnerLoading
}: IButtonBaseState) => {
  const isPrimary = variant === BUTTON_VARIANTS.PRIMARY;

  const isSecondaryLikeVariant = [BUTTON_VARIANTS.SECONDARY, BUTTON_VARIANTS.TERTIARY, BUTTON_VARIANTS.QUATERNARY];
  const isLoadingDisabledVariant = isLoading && isSecondaryLikeVariant.includes(variant);
  const isLoadingPrimaryLink = isLoading && isPrimary && hasHref && !isInlineSpinnerLoading;
  const hasAriaDisabledState = Boolean(disabled || isLoadingDisabledVariant || isLoadingPrimaryLink);

  return {
    isPrimary,
    loadingDisabled: disabled || (isLoading && !isInlineSpinnerLoading),
    showIcon: isInlineSpinnerLoading ? undefined : icon,
    hasAriaDisabledState
  };
};
